(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('general-settings', {
            parent: 'account',
            url: '/general-settings',
            data: {
                authorities: ['ROLE_DOMAIN_ADMIN', 'ROLE_DOMAIN_USER'],
                pageTitle: 'global.menu.account.generalSettings'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/general-settings/general-settings.html',
                    controller: 'GeneralSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('generalSettings');
                    $translatePartialLoader.addPart('tabDomains');
                    $translatePartialLoader.addPart('myChannel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                domain: ['TabDomains', 'Principal', '$q', function (TabDomains, Principal, $q) {
                    var deferred = $q.defer();
                    Principal.identity().then(function (account) {
                        deferred.resolve(TabDomains.current());
                    });
                    return deferred.promise;
                }],
                maintenanceSetting: ['MaintenanceSettingsService', function (MaintenanceSettingsService) {
                    return MaintenanceSettingsService.get();
                }]
            }
        });
    }
})();
